import { gql, useQuery } from '@apollo/client';

import { usePatient } from 'hooks/usePatient/usePatient';
import { utils } from 'kb-shared';
import { getLabInfo, LabInfo } from 'kb-shared/utilities/kindbody_contacts';
import { isPortlandPatient } from 'kb-shared/utilities/lab.helper';
import { formatPhoneNumber } from 'kb-shared/utilities/phones';
import { memberServicesPhone } from 'screens/Book/memberServicesPhone';

type ResponseData = {
  journeyType: string;
};

const CONTACT_INFO = gql`
  query contactInfo {
    journeyType
  }
`;

export const useContactInfo = () => {
  const { patient, isLoggedIn } = usePatient();

  const defaultLabInfo = getLabInfo();
  const marketId = patient?.lab?.id || '';
  const withNetworkPhone = (labInfo: LabInfo): LabInfo => {
    const phoneNumber = memberServicesPhone(patient?.patientMembership?.employerPhone);

    return {
      ...labInfo,
      number: phoneNumber,
      numberLabel: formatPhoneNumber(phoneNumber) || phoneNumber
    };
  };

  const { data, error } = useQuery<ResponseData>(CONTACT_INFO, {
    skip: !isLoggedIn
  });

  if (!isLoggedIn) return defaultLabInfo;

  const info = getLabInfo(marketId);

  if (patient?.patientMembership?.employer) {
    return withNetworkPhone({
      ...info,
      email: utils.KBContacts.employeeBenefitsEmail
    });
  }

  if (isPortlandPatient(marketId)) {
    return withNetworkPhone(getLabInfo(marketId));
  }

  if (!data || error || !data.journeyType) {
    return withNetworkPhone({
      ...info,
      email: defaultLabInfo.email
    });
  }

  return withNetworkPhone(info);
};

export default useContactInfo;
